import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions, combineActions } from 'redux-actions';
import { addModule, addModuleFail, addModuleSuccess, updateModuleOrderSuccess, updateLayoutVersion, fetchLayoutSuccess } from '../actions/layout';
const defaultState = {};
// merge-update zone state
const updateZoneState = (state, zoneName, zoneStateSlice)=>{
    return _object_spread_props(_object_spread({}, state), {
        layout: _object_spread_props(_object_spread({}, state.layout), {
            zones: _object_spread_props(_object_spread({}, state.layout.zones), {
                [zoneName]: _object_spread({}, state.layout.zones[zoneName], zoneStateSlice)
            })
        })
    });
};
export default handleActions({
    [fetchLayoutSuccess.toString()]: (state, action)=>_object_spread({}, state, action.payload),
    [updateLayoutVersion.toString()]: (state, action)=>{
        const { version } = action.payload;
        return _object_spread_props(_object_spread({}, state), {
            layout: _object_spread_props(_object_spread({}, state.layout), {
                version
            })
        });
    },
    [updateModuleOrderSuccess.toString()]: (state, action)=>{
        const { zoneName, order: installedModulesIds } = action.payload;
        return updateZoneState(state, zoneName, {
            installedModulesIds
        });
    },
    [addModule.toString()]: (state, action)=>{
        const { payload } = action;
        if (!payload) {
            return;
        }
        const { zoneName, position } = payload;
        return updateZoneState(state, zoneName, {
            isInstallingModule: true,
            currentlyInstalledModulePostion: position
        });
    },
    [combineActions(addModuleSuccess, addModuleFail).toString()]: (state, action)=>{
        const { payload } = action;
        if (!payload) {
            return;
        }
        const { zoneName } = payload;
        return updateZoneState(state, zoneName, {
            isInstallingModule: false,
            currentlyInstalledModulePostion: undefined
        });
    }
}, defaultState);
